import { Link } from '@tanstack/react-router';
import { Sticker } from '@/components/ui';
import { CodeRequestForm } from '@/features/auth/request-form';

export function ForgotPage() {
  return (
    <div className="flex flex-col gap-6">
      <div>
        <Sticker flavor="peach" rotate={-3}>
          reset it
        </Sticker>
        <h1 className="mt-4 text-3xl font-semibold">Forgot your password?</h1>
        <p className="mt-2 text-sm text-ink-soft">
          We’ll email you a code. Enter it and pick a new password on the next screen.
        </p>
      </div>
      <CodeRequestForm intent="reset" />
      <p className="text-sm text-ink-soft">
        Remembered it?{' '}
        <Link to="/login" className="font-semibold underline">
          Back to log in
        </Link>
      </p>
    </div>
  );
}
